export const trackMidaABTestEvent = (event: string) => {
  window.mdq = window.mdq || []
  window.mdq.push(["track", event])
}
